export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.js-signed-in')) {
      fetch('/api/me.json').then((res) => {
        res.json().then((data) => {
          if (data.me) {
            document.querySelectorAll('.js-signed-in').forEach((el) => {
              el.style.display = el.dataset.display || 'block'
            })
            document
              .querySelectorAll('.js-me-current_bonus_balance')
              .forEach((el) => {
                el.innerHTML = data.me.current_bonus_balance
              })
          } else {
            document.querySelectorAll('.js-signed-in').forEach((el) => {
              if (el.dataset.display != 'none') {
                el.style.display = 'none'
              }
            })
          }
        })
      })
    }
  })
})()
